export const getAustraliaData = () => ({
  name: "Australie",
  description: "L'Australie est un pays viticole moderne et innovant, produisant des vins de qualité internationale. Avec ses vastes territoires et climats diversifiés, l'Australie offre une grande variété de styles de vins, du Shiraz puissant de la Barossa Valley aux Chardonnay élégants de Margaret River.",
  type: "country",
  regions: [
    { name: "Barossa Valley", area: "11,000 ha", percentage: "12%", description: "Shiraz emblématique" },
    { name: "Hunter Valley", area: "8,000 ha", percentage: "9%", description: "Plus ancienne région" },
    { name: "Margaret River", area: "6,000 ha", percentage: "7%", description: "Vins blancs élégants" },
    { name: "McLaren Vale", area: "7,000 ha", percentage: "8%", description: "Vins de qualité" },
    { name: "Yarra Valley", area: "5,000 ha", percentage: "6%", description: "Vins frais" },
    { name: "Autres", area: "55,000 ha", percentage: "58%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Barossa Valley", x: 138.8, y: -34.5, color: "#4B164C", size: 6 },
    { region: "Hunter Valley", x: 151.5, y: -32.8, color: "#6d2c7a", size: 5 },
    { region: "Margaret River", x: 115.0, y: -33.9, color: "#8a4a8a", size: 4 },
    { region: "McLaren Vale", x: 138.5, y: -35.2, color: "#a768a6", size: 4 },
    { region: "Yarra Valley", x: 145.5, y: -37.7, color: "#c486c4", size: 3 }
  ],
  statistics: {
    totalArea: "92,000 ha",
    production: "13 million hectolitres",
    regions: "6 régions principales",
    appellations: "65+ appellations",
    exportPercentage: "60%"
  },
  characteristics: {
    climate: "Climats diversifiés : méditerranéen, continental, océanique",
    soil: "Sols variés : calcaires, argileux, sableux, excellente diversité géologique",
    viticulture: "Innovation technologique, viticulture durable, rendements contrôlés"
  },
  wineStyles: {
    red: "Vins rouges puissants et fruités, avec des tanins mûrs et une excellente concentration",
    white: "Vins blancs frais et aromatiques, avec une belle acidité et des notes tropicales",
    rosé: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle et Charmat"
  },
  history: "La viticulture australienne remonte à l'arrivée des colons britanniques en 1788. Les premiers vignobles ont été plantés dans la Hunter Valley. L'immigration européenne au XIXe siècle a apporté de nouvelles techniques et cépages. Le Shiraz est devenu le cépage emblématique de l'Australie. Aujourd'hui, l'Australie est reconnue pour ses vins de qualité et son innovation viticole.",
  foodPairing: "Cuisine australienne : barbecue, fruits de mer, viandes rouges, cuisine fusion. Les vins australiens s'accordent parfaitement avec la gastronomie internationale et les plats épicés."
}); 